// import React, { useState } from "react";
// import axios from "axios";
// import secureLocalStorage from "./storage";
// import {
//   Dialog, DialogContent, IconButton, Typography, TextField, Button,
//   ToggleButton, ToggleButtonGroup, Alert, Stack,
// } from "@mui/material";
// import { Close } from "@mui/icons-material";

// const WithdrawDialog = ({ open, onClose, balance, minAmount, defaultName, onSuccess }) => {
//   const token = secureLocalStorage.getItem("n_token");
//   const [method, setMethod] = useState("upi");
//   const [form, setForm] = useState({
//     full_name: defaultName || "", amount: "", upi_id: "", account_number: "", ifsc: "",
//   });
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");

//   const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

//   const submit = async () => {
//     setError("");
//     if (form.full_name.trim().length < 3) return setError("Please enter your full name");
//     const amt = Number(form.amount);
//     if (!(amt >= minAmount)) return setError(`Minimum withdrawal is ₹${minAmount}`);
//     if (amt > balance) return setError("Amount is more than your available balance");

//     setLoading(true);
//     try {
//       const res = await axios.post(
//         `${process.env.REACT_APP_API}website/withdraw_request`,
//         { ...form, amount: amt, method },
//         { headers: { token } }
//       );
//       if (res.data?.success) {
//         onSuccess && onSuccess();
//         onClose();
//       }
//     } catch (err) {
//       setError(err?.response?.data?.message || "Could not submit request");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
//       <DialogContent sx={{ p: 3, position: "relative" }}>
//         <IconButton onClick={onClose} sx={{ position: "absolute", right: 12, top: 12 }}>
//           <Close />
//         </IconButton>
//         <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>Withdraw Cashback</Typography>
//         <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
//           Available: ₹{balance} &nbsp;|&nbsp; Minimum: ₹{minAmount}
//         </Typography>

//         <Stack spacing={2}>
//           {error && <Alert severity="error">{error}</Alert>}

//           <TextField label="Full name (as per bank/UPI)" value={form.full_name} onChange={set("full_name")} fullWidth size="small" />
//           <TextField label="Amount (₹)" type="number" value={form.amount} onChange={set("amount")} fullWidth size="small" />

//           <ToggleButtonGroup value={method} exclusive onChange={(e, v) => v && setMethod(v)} size="small" fullWidth>
//             <ToggleButton value="upi">UPI</ToggleButton>
//             <ToggleButton value="bank">Bank Transfer</ToggleButton>
//           </ToggleButtonGroup>

//           {method === "upi" ? (
//             <TextField label="UPI ID" placeholder="name@upi" value={form.upi_id} onChange={set("upi_id")} fullWidth size="small" />
//           ) : (
//             <>
//               <TextField label="Account number" value={form.account_number} onChange={set("account_number")} fullWidth size="small" />
//               <TextField label="IFSC code" value={form.ifsc} onChange={set("ifsc")} fullWidth size="small" />
//             </>
//           )}

//           <Button
//             variant="contained" onClick={submit} disabled={loading}
//             sx={{ backgroundColor: "#2f5bff", "&:hover": { backgroundColor: "#1a3fd6" }, py: 1.2 }}
//           >
//             {loading ? "Please wait..." : "Request Withdrawal"}
//           </Button>
//         </Stack>
//       </DialogContent>
//     </Dialog>
//   );
// };

// export default WithdrawDialog;

import React, { useState } from "react";
import axios from "axios";
import secureLocalStorage from "./storage";
import {
  Dialog, DialogContent, IconButton, Typography, TextField, Button,
  ToggleButton, ToggleButtonGroup, Alert, Stack,
} from "@mui/material";
import { Close } from "@mui/icons-material";

const emptyForm = {
  account_holder_name: "",
  amount: "",
  upi_id: "",
  bank_name: "",
  account_number: "",
  confirm_account_number: "",
  ifsc: "",
};

const WithdrawDialog = ({ open, onClose, balance, minAmount, onSuccess }) => {
  const token = secureLocalStorage.getItem("n_token");
  const [method, setMethod] = useState("upi");
  const [form, setForm] = useState(emptyForm);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const set = (k) => (e) => {
    const value = e.target.value;
    setForm((prev) => ({ ...prev, [k]: value }));
  };

  // account number me sirf digits
  const setDigits = (k) => (e) => {
    const value = e.target.value.replace(/\D/g, "");
    setForm((prev) => ({ ...prev, [k]: value }));
  };

  // IFSC hamesha uppercase
  const setIfsc = (e) => {
    const value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "");
    setForm((prev) => ({ ...prev, ifsc: value }));
  };

  const changeMethod = (e, v) => {
    if (!v) return;
    setMethod(v);
    setError("");
    // tab badalne par dusre method ke fields clear
    setForm((prev) => ({
      ...prev,
      upi_id: "",
      bank_name: "",
      account_number: "",
      confirm_account_number: "",
      ifsc: "",
    }));
  };

  const handleClose = () => {
    setForm(emptyForm);
    setMethod("upi");
    setError("");
    onClose();
  };

  const submit = async () => {
    setError("");

    if (form.account_holder_name.trim().length < 3)
      return setError("Please enter the account holder name");

    const amt = Number(form.amount);
    if (!(amt >= minAmount)) return setError(`Minimum withdrawal is ₹${minAmount}`);
    if (amt > balance) return setError("Amount is more than your available balance");

    let payload = {
      account_holder_name: form.account_holder_name.trim(),
      amount: amt,
      method,
    };

    if (method === "upi") {
      if (!/^[\w.\-]{2,}@[a-zA-Z]{2,}$/.test(form.upi_id.trim()))
        return setError("Please enter a valid UPI ID");
      payload.upi_id = form.upi_id.trim();
    } else {
      if (form.bank_name.trim().length < 2) return setError("Please enter the bank name");
      if (!/^\d{9,18}$/.test(form.account_number))
        return setError("Please enter a valid account number");
      if (form.account_number !== form.confirm_account_number)
        return setError("Account numbers do not match");
      if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(form.ifsc))
        return setError("Please enter a valid IFSC code");

      payload.bank_name = form.bank_name.trim();
      payload.account_number = form.account_number;
      payload.confirm_account_number = form.confirm_account_number;
      payload.ifsc = form.ifsc;
    }

    setLoading(true);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API}website/withdraw_request`,
        payload,
        { headers: { token } }
      );
      if (res.data?.success) {
        onSuccess && onSuccess();
        handleClose();
      }
    } catch (err) {
      setError(err?.response?.data?.message || "Could not submit request");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogContent sx={{ p: 3, position: "relative" }}>
        <IconButton onClick={handleClose} sx={{ position: "absolute", right: 12, top: 12 }}>
          <Close />
        </IconButton>
        <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>Withdraw Cashback</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Available: ₹{Number(balance || 0).toFixed(2)} &nbsp;|&nbsp; Minimum: ₹{minAmount}
        </Typography>

        <Stack spacing={2}>
          {error && <Alert severity="error">{error}</Alert>}

          <TextField
            label="Account holder name (as per bank/UPI)"
            value={form.account_holder_name}
            onChange={set("account_holder_name")}
            fullWidth size="small"
          />
          <TextField
            label="Amount (₹)" type="number"
            value={form.amount} onChange={set("amount")}
            fullWidth size="small"
          />

          <ToggleButtonGroup value={method} exclusive onChange={changeMethod} size="small" fullWidth>
            <ToggleButton value="upi">UPI</ToggleButton>
            <ToggleButton value="bank">Bank Transfer</ToggleButton>
          </ToggleButtonGroup>

          {method === "upi" ? (
            <TextField
              label="UPI ID" placeholder="name@upi"
              value={form.upi_id} onChange={set("upi_id")}
              fullWidth size="small"
            />
          ) : (
            <>
              <TextField
                label="Bank name"
                value={form.bank_name} onChange={set("bank_name")}
                fullWidth size="small"
              />
              <TextField
                label="Account number"
                value={form.account_number} onChange={setDigits("account_number")}
                inputProps={{ inputMode: "numeric", maxLength: 18 }}
                fullWidth size="small"
              />
              <TextField
                label="Confirm account number"
                value={form.confirm_account_number} onChange={setDigits("confirm_account_number")}
                inputProps={{ inputMode: "numeric", maxLength: 18 }}
                onPaste={(e) => e.preventDefault()}
                error={
                  !!form.confirm_account_number &&
                  form.account_number !== form.confirm_account_number
                }
                helperText={
                  form.confirm_account_number &&
                  form.account_number !== form.confirm_account_number
                    ? "Account numbers do not match"
                    : ""
                }
                fullWidth size="small"
              />
              <TextField
                label="IFSC code"
                value={form.ifsc} onChange={setIfsc}
                inputProps={{ maxLength: 11 }}
                fullWidth size="small"
              />
            </>
          )}

          <Button
            variant="contained" onClick={submit} disabled={loading}
            sx={{ backgroundColor: "#2f5bff", "&:hover": { backgroundColor: "#1a3fd6" }, py: 1.2 }}
          >
            {loading ? "Please wait..." : "Request Withdrawal"}
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default WithdrawDialog;